(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 2500);
  }
  function refreshCount() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; e.hidden = c.item_count === 0; });
    }).catch(function () {});
  }
  function addToCart(fd) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
  }

  /* quick add from cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.js-atc'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    var fd = new FormData(); fd.append('id', b.dataset.id); fd.append('quantity', 1);
    addToCart(fd).then(function () { toast('Added to cart'); return refreshCount(); })
      .catch(function (err) { toast(err.message); })
      .then(function () { b.disabled = false; });
  });

  /* product form */
  $$('.js-product-form').forEach(function (form) {
    var btn = $('[data-atc]', form);
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault(); btn.disabled = true;
      addToCart(new FormData(form)).then(function () { toast('Added to cart'); return refreshCount(); })
        .catch(function (err) { toast(err.message); })
        .then(function () { btn.disabled = false; });
    });
    var sel = $('[data-variant-select]', form);
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var now = $('[data-price-now]'), was = $('[data-price-was]');
      if (now) now.textContent = o.dataset.price;
      if (was) { was.textContent = o.dataset.was; was.hidden = !o.dataset.was; }
      var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState({}, '', u);
    });
  });

  /* gallery */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-main-img]', g) || $('.pdp__main img', g);
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = t.dataset.src; }
        $$('[data-thumb]', g).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* mobile menu */
  var nav = $('[data-nav]');
  var tg = $('[data-menu-toggle]');
  if (nav && tg) {
    tg.addEventListener('click', function () { nav.classList.toggle('is-open'); });
    document.addEventListener('click', function (e) { if (nav.classList.contains('is-open') && !nav.contains(e.target) && !tg.contains(e.target)) nav.classList.remove('is-open'); });
  }

  /* product sliders */
  $$('[data-slider]').forEach(function (s) {
    var tr = $('[data-track]', s), bar = $('[data-bar]', s); if (!tr) return;
    function upd() {
      if (!bar) return;
      var max = tr.scrollWidth - tr.clientWidth;
      var vis = Math.min(1, tr.clientWidth / tr.scrollWidth);
      bar.style.width = (vis * 100) + '%';
      var p = max > 0 ? tr.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (p * (1 / vis - 1) * 100) + '%)';
    }
    tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });

  /* hero */
  $$('[data-hero]').forEach(function (h) {
    var tr = $('[data-hero-track]', h), slides = $$('.hero__slide', h), dotsBox = $('[data-hero-dots]', h);
    if (!tr || slides.length < 2) return;
    var idx = 0, dots = [], timer;
    function go(i) { idx = (i + slides.length) % slides.length; tr.scrollTo({ left: idx * tr.clientWidth, behavior: 'smooth' }); mark(); }
    function mark() { dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); }); }
    slides.forEach(function (_, i) {
      var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Slide ' + (i + 1));
      d.addEventListener('click', function () { go(i); play(); }); dotsBox.appendChild(d); dots.push(d);
    });
    mark();
    tr.addEventListener('scroll', function () { var n = Math.round(tr.scrollLeft / tr.clientWidth); if (n !== idx) { idx = n; mark(); } }, { passive: true });
    var p = $('[data-hero-prev]', h), n = $('[data-hero-next]', h);
    if (p) p.addEventListener('click', function () { go(idx - 1); play(); });
    if (n) n.addEventListener('click', function () { go(idx + 1); play(); });
    function play() {
      clearInterval(timer);
      if (h.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { go(idx + 1); }, +h.dataset.interval || 6000);
    }
    h.addEventListener('mouseenter', function () { clearInterval(timer); }); h.addEventListener('mouseleave', play); play();
  });

  /* tabs */
  $$('[data-tabs]').forEach(function (box) {
    var tabs = $$('[data-tab]', box), panels = $$('[data-panel]', box);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
      });
    });
  });

  /* collection sort + filters */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u;
  });
  var filters = $('[data-filters]');
  if (filters) filters.addEventListener('change', function () {
    var p = new URLSearchParams();
    new FormData(filters).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    location.search = p.toString();
  });

  /* cart qty auto update */
  $$('[data-cart-qty]').forEach(function (i) { i.addEventListener('change', function () { var f = i.closest('form'); var b = document.createElement('input'); b.type = 'hidden'; b.name = 'update'; b.value = '1'; f.appendChild(b); f.submit(); }); });
})();
